module.exports = __webpack_public_path__ + "img/20210420_121410.8e810305.jpg";